import Api from "../../../Services/Api";

export const fetchDataItem = async (type, body) => {
  switch (type) {
    case "Job":
      try {
        // const res = await Api.create(
        //   "NAGAMAS_MASTER_DATA"
        // ).getServiceForPackage();

        // Adjusment job by kode variant
        const kodeVariantList = body?.kodeVariant || [];
        const query = kodeVariantList
          .map((v) => `kodeVariant=${encodeURIComponent(v)}`)
          .join("&");

        const res = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getServiceForPackage(`?${query}`);

        return res.data.data?.map((item) => ({
          value: item?.serviceCode,
          label: item?.serviceName,
          serviceCategory: item?.serviceCategory,
          estimationTime: item?.estimationTime,
        }));
      } catch (error) {
        console.log("errors: ", error);
        return null;
      }
    case "Part":
      try {
        const res = await Api.create("NAGAMAS_MASTER_DATA").getPartForPackage();
        return res.data.data?.map((item) => ({
          value: item?.kodePart,
          label: item?.partName,
          partCategory: item?.partCategory,
          satuan: item?.satuan,
        }));
      } catch (error) {
        console.log("errors: ", error);
        return null;
      }
  }
};
